import { FooterLinksCategory } from "./FooterLinksCategory";

export { FooterLinksCategory };
